module.exports = __webpack_public_path__ + "static/media/sb13.f726dfc6.png";